import type { CoverageSummary } from "../domain/coverage";

interface CoverageMeterProps {
  coverage: CoverageSummary;
}

export function CoverageMeter({ coverage }: CoverageMeterProps) {
  const { overall } = coverage;
  return (
    <div>
      <div className="coverage-meter">
        <div
          className="bar-track"
          role="meter"
          aria-label="Cobertura de campos candidatos enmascarados"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={overall.percentage}
        >
          <div className="bar-fill" style={{ width: `${overall.percentage}%` }} />
        </div>
        <span className="bar-value">{overall.percentage}%</span>
      </div>
      <table className="coverage-table">
        <caption>Resumen textual equivalente de la cobertura</caption>
        <thead>
          <tr>
            <th scope="col">Campos candidatos a PII</th>
            <th scope="col">Cubiertos con una regla activa</th>
            <th scope="col">Sin cubrir</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{overall.relevant}</td>
            <td>{overall.covered}</td>
            <td>{overall.relevant - overall.covered}</td>
          </tr>
        </tbody>
      </table>
      {coverage.combinationRisk ? (
        <p className="field-error" role="alert">
          Riesgo de combinación: {coverage.combinationRiskFields.join(", ")} quedan sin enmascarar a la vez.
        </p>
      ) : null}
    </div>
  );
}
